/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const telos_chain_about = () => `Telos is a blockchain platform built on EOSIO software, focusing on governance, scalability, and sustainability. It features transparent governance allowing token holders to participate in decision-making. With advanced resource management and a Delegated Proof-of-Stake consensus, Telos achieves high scalability. It emphasizes environmental consciousness and fosters a strong community of developers and users.`
